import React from "react"
import { TextField, Toggle, Paper } from "material-ui"
import strings from "../../../localization/strings"
import { IHierarchyDefinition } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import accountStore from "../../../stores/AccountStore"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"

interface IProps {
    index: number
    item: IHierarchyDefinition
    editable: boolean
    explicitAccountUserHierarchyAssignment: boolean
    explicitEmployeeHierarchyAssignment: boolean
    handleItem(index: number, propertyName: string, value: any): void
    handleBlur(): void
    handleEditable(index: number): void
}

const AccountHierarchyDefinitionItem: React.SFC<IProps> = (props: IProps) => {
    const editable = () => {
        props.handleEditable(props.index)
    }

    const handleItem = (event, value) => {
        props.handleItem(props.index, event._targetInst._currentElement.props.name, value)
    }

    const messageForDisablePunches =
        !props.item.EnablePunches ?
            props.item.MessageForDisablePunches !== null ?
                props.item.MessageForDisablePunches :
                strings.Punches_are_not_allowed_at_this_location :
            null

    return (
        <Paper style={{ marginBottom: 40, minHeight: 100, position: "relative" }}>
            <i
                style={{ position: "absolute", right: 10, top: 10, fontSize: 18 }}
                className={!props.editable ? "fa fa-chevron-down itemActionButton" : "fa fa-chevron-up itemActionButton"}
                onClick={editable}
            />
            {!props.editable ?
                <div>
                    <div style={{ color: (!props.item.Label.length || props.item.Label.length > 50) && "rgb(244, 67, 54)", fontSize: "20px", fontWeight: "bold", marginLeft: "30px", paddingTop: "20px" }}>
                        {props.item.Label}
                    </div>
                    <div style={{ fontSize: "15px", marginLeft: "30px", marginTop: "8px" }}>
                        {strings.Level} {props.item.Level + 1}
                    </div>
                </div> :
                <div >
                    <TextField
                        name="Label"
                        floatingLabelText="Level Label"
                        value={props.item.Label}
                        style={{ marginLeft: "30px", fontSize: "20px", fontWeight: "bold" }}
                        floatingLabelStyle={{ fontSize: "13px" }}
                        onChange={handleItem}
                        onBlur={e => {
                            const inputLength = props.item.Label.length
                            inputLength && inputLength <= 50 && props.handleBlur()
                        }}
                        onFocus={e => {
                            e.target.selectionStart = props.item.Label.length
                        }}
                        errorText={(!props.item.Label.length && "Item must have a label") || (props.item.Label.length > 50 && "Label length cannot exceed 50 characters")}
                    />
                    <div style={{ fontSize: "15px", marginLeft: "30px", marginBottom: "20px" }}>
                        {strings.Level} {props.item.Level + 1}
                    </div>
                    <Toggle
                        name="EnableLocations"
                        label={strings.Allow_GPS_Locations}
                        toggled={props.item.EnableLocations}
                        onToggle={handleItem}
                        style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                        labelStyle={{ fontSize: "15px" }}
                    />
                    <Toggle
                        name="EnableMicroLocations"
                        label={strings.Allow_MicroLocations}
                        toggled={props.item.EnableMicroLocations}
                        onToggle={handleItem}
                        style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                        labelStyle={{ fontSize: "15px" }}
                    />
                    {AccountStore.getJobsEnabled() &&
                        <Toggle
                            name="EnableJob"
                            label={checkJobFieldAvailable("singular") ? `Allow ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Allow_Job}
                            toggled={props.item.EnableJob}
                            onToggle={handleItem}
                            style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                            labelStyle={{ fontSize: "15px" }}
                        />
                    }
                    <Toggle
                        name="EnablePositions"
                        label={checkPositionFieldAvailable('plural') ? `Allow ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}` : strings.Allow_Positions}
                        toggled={props.item.EnablePositions}
                        onToggle={handleItem}
                        style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                        labelStyle={{ fontSize: "15px" }}
                        disabled={!props.item.EnablePunches}
                    />
                    {props.explicitEmployeeHierarchyAssignment &&
                        <Toggle
                            name="EnableEmployees"
                            label={strings.Allow_Attached_Employees}
                            toggled={props.item.EnableEmployees}
                            onToggle={handleItem}
                            style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                            labelStyle={{ fontSize: "15px" }}
                        />
                    }
                    {props.explicitAccountUserHierarchyAssignment &&
                        <Toggle
                            name="EnableAccountUsers"
                            label={strings.Allow_Attached_Users}
                            toggled={props.item.EnableAccountUsers}
                            onToggle={handleItem}
                            style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                            labelStyle={{ fontSize: "15px" }}
                        />
                    }
                    {AccountStore.getExpensesEnabled() &&
                        <Toggle
                            name="DisableExpense"
                            label={strings.Disable_Expense}
                            toggled={props.item.DisableExpense}
                            onToggle={handleItem}
                            style={{ maxWidth: 250, marginLeft: "30px", marginBottom: "20px" }}
                            labelStyle={{ fontSize: "15px" }}
                        />
                    }
                    <div style={{ display: "flex", paddingBottom: 15 }}>
                        <Toggle
                            name="EnablePunches"
                            label={strings.Allow_Punches}
                            toggled={props.item.EnablePunches}
                            onToggle={handleItem}
                            style={{ maxWidth: 250, marginLeft: 30 }}
                            labelStyle={{ fontSize: 15 }}
                        />
                        {!props.item.EnablePunches &&
                            <TextField
                                name="MessageForDisablePunches"
                                floatingLabelText={strings.Disable_Message}
                                style={{ marginTop: -28, marginLeft: 30, marginRight: 30, width: 600 }}
                                value={messageForDisablePunches}
                                onChange={handleItem}
                                onFocus={e => e.target.selectionStart = messageForDisablePunches.length}
                                onBlur={() => props.item.MessageForDisablePunches.length && props.handleBlur()}
                                errorText={!messageForDisablePunches.length && strings.This_field_is_required}
                            />
                        }
                    </div>
                </div>
            }
        </Paper>
    )
}

export default AccountHierarchyDefinitionItem
